const BASE62 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
//  Uint8Array
export function uuidToBytes(uuid: string): Uint8Array {
  const hex = uuid.replace(/-/g, '');
  const bytes = new Uint8Array(16);
  for (let i = 0; i < 16; i++) {
    bytes[i] = parseInt(hex.substr(i * 2, 2), 16);
  }
  return bytes;
}

// Base62 end 8 code
export function encode8(userId: string): string {
  const bytes = uuidToBytes(userId);
  // 取前 6 字节
  let val =
    (BigInt(bytes[0]) << 40n) |
    (BigInt(bytes[1]) << 32n) |
    (BigInt(bytes[2]) << 24n) |
    (BigInt(bytes[3]) << 16n) |
    (BigInt(bytes[4]) << 8n) |
    BigInt(bytes[5]);
  let code = '';
  for (let i = 0; i < 8; i++) {
    const idx = Number(val % 62n);
    code = BASE62[idx] + code;
    val = val / 62n;
  }
  return code;
};